import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { TbAlertTriangle } from "react-icons/tb";
import logo from "../assets/cogniflock_logo_full.svg";
import { getApiBaseUrl } from "../utils/apiConfig";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const { token } = useParams(); // if your route is /reset-password/:token
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const apiUrl = getApiBaseUrl();
      await axios.post(`${apiUrl}/auth/reset-password`, {
        resetToken: token,
        newPassword,
      });
      navigate("/login");
      // Redirect user to login page or somewhere else
    } catch (err) {
      console.error(err);
      setError(
        err.response?.data?.message ||
          "No user found with that email" ||
          "Error resetting password"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-bg-gradient-dash">
      <div className="w-full max-w-sm p-6 flex flex-col gap-10">
        <img src={logo} alt="Logo" className="h-9" />{" "}
        <div className="relative w-full flex flex-col gap-3">
          <div className="w-full max-w-md flex flex-col gap-4 p-6 bg-white-f border border-grey-20 rounded-xl shadow-sm">
            <div className="flex flex-col gap-2 mb-3">
              {" "}
              <h2 className="text-xl  font-normal text-black-0">
                Set a new password
              </h2>
              <p className="text-sm  font-normal text-grey-60">
                Please enter a new password below. Make sure it’s strong and
                secure.{" "}
              </p>
            </div>
            <form
              onSubmit={handleResetPassword}
              className="flex flex-col gap-7"
            >
              <div className="flex flex-col gap-1">
                <label className="text-grey-60 text-sm  font-medium">
                  New Password
                </label>
                <input
                  className="w-full px-3 py-1 border border-grey-30 rounded-md focus:outline-none"
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                />
              </div>

              <button
                className="w-full py-2 px-4 bg-brand text-white-f text-sm  font-medium tracking-wide rounded-md hover:bg-brand-dark transition"
                type="submit"
                disabled={loading}
              >
                {loading ? (
                  <div className="inline-block align-middle w-4 h-4 border-2 border-t-2 border-t-white-f border-bg-opacity rounded-full animate-spin"></div>
                ) : (
                  "Reset Password"
                )}
              </button>
              {error && (
                <div className="flex gap-2 items-center text-center">
                  <TbAlertTriangle className="size-5 text-red-strong" />{" "}
                  <p className="text-red-strong text-sm  font-normal ">
                    {error}
                  </p>
                </div>
              )}
            </form>
          </div>
          {/* Decorative lines */}
          <div className="absolute -top-20 -bottom-8 -left-2 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-20 -right-2 -bottom-8 w-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_top,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -top-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
          <div className="absolute -bottom-2 -right-20 -left-20 h-px bg-slate-900/[0.1] [mask-image:linear-gradient(to_right,transparent,white_4rem,white_calc(100%-4rem),transparent)]"></div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
